<template>
  <div>
    <div class="grid-content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>员工模块</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: 'employeeList' }">员工列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: 'employeeWorkload' ,query:{...backData} }">员工工作量</el-breadcrumb-item>
        <el-breadcrumb-item>新增工作量</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row :gutter="0" class="grid-content">
      <el-col :span="12">
        <div class="inputDiv">
          <div class="inputLeft">员工姓名：</div>
          <el-input
            v-model="backData.staffName"
            :disabled="true"
            class="inputRight"
            style="width: unset;"
            placeholder="请输入员工姓名"
          ></el-input>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">时间:</span>
          <el-date-picker
            v-model="month"
            type="date"
            value-format="yyyy-MM-dd"
            style="width:200px"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
        <div class="inputDiv">
          <span class="inputLeft">批次：</span>
          <el-select
            v-model="batchId"
            style="width:200px"
            filterable
            placeholder="请选择批次"
            @change="getProcessList"
          >
            <el-option
              v-for="item in batchList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>

        <div class="inputDiv">
          <span class="inputLeft">工序：</span>
          <el-select v-model="process" filterable style="width:200px" placeholder="请选择工序">
            <el-option
              v-for="item in processList"
              :key="item.value"
              :label="item.label"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">单价：</div>
          <div class="inputRight" style="width: 194.2px;">{{process.unitSalary}}(元)</div>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">完成件数：</div>
          <el-input
            v-model="amount"
            type="number"
            class="inputRight"
            style="width: unset;"
            placeholder="请输入完成件数"
            @input="sum"
          ></el-input>
        </div>
        <div class="inputDiv">
          <div class="inputLeft">总价：</div>
          <div class="inputRight" style="width: 194.2px;">{{salary}}(元)</div>
        </div>
        <div class="inputDiv">
          <el-button type="primary" class="widthButton" @click="addWork">确认</el-button>
          <el-button class="widthButton" @click="back">取消</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { batchSel, processSel } from "@/api/batch";
import { workRecordAdd } from "@/api/workRecord";
import moment from "moment";
export default {
  data() {
    return {
      batchId: "",
      batchList: [],
      process: {
        unitSalary: 0
      },
      processList: [],
      amount: "",
      salary: 0,
      month: moment(new Date()).format("YYYY-MM-DD"),
      backData: {}
    };
  },
  mounted() {
    this.backData = {
      staffName: this.$route.query.staffName,
      id: this.$route.query.id,
      tel: this.$route.query.tel,
      month: this.$route.query.month
    };
    this.getBatch(1);
  },
  methods: {
    getBatch(pageNum) {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        username: localStorage.getItem("user_name"),
        progress: 1,
        pageNum: pageNum,
        pageSize: 100
      };

      batchSel(params)
        .then(res => {
          res.gridData.forEach(element => {
            var batch = {
              value: element.id,
              label: element.title
            };
            this.batchList.push(batch);
          });
          if (pageNum < res.page.page_total) {
            this.getBatch(pageNum + 1);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    sum() {
      this.salary = (this.amount * this.process.unitSalary).toFixed(4);
    },
    getProcessList() {
      this.processList = [];
      this.getProcess(1);
    },
    back() {
      this.$router.go(-1);
    },
    addWork() {
      const params = {
        userId: this.backData.id,
        workDate: this.month,
        batchId: this.batchId,
        processId: this.process.value,
        amount: this.amount
      };
      console.log(params);
      workRecordAdd(params)
        .then(res => {
          console.log(res);
          this.$message({
            type: "success",
            message: "添加成功!"
          });
          this.back();
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProcess(pageNum) {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        batchId: this.batchId,
        pageNum: pageNum,
        pageSize: 300
      };
      processSel(params)
        .then(res => {
          res.gridData.forEach(element => {
            var process = {
              value: element.id,
              label: element.name,
              unitSalary: element.unitSalary
            };
            this.processList.push(process);
          });
          if (pageNum < res.page.page_total) {
            this.getProcess(pageNum + 1);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style>
</style>
